import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Modal from '../general/Modal';
import Xbutton from '@/assets/xLight.svg';

interface PaletteCreateProps {
  onCreateNewPalette: (name: string) => void;
}

const PaletteCreate = forwardRef<{ openDialog: () => void }, PaletteCreateProps>((props, ref) => {
  const { onCreateNewPalette } = props;
  const [open, setOpen] = useState(false);
  const [paletteName, setPaletteName] = useState('');
  const [error, setError] = useState('');

  const openDialog = () => {
    setOpen(true);
    setError('');
  };

  const closeDialog = () => {
    setOpen(false);
    setPaletteName('');
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!paletteName.trim()) {
      setError('Name is required');
      return;
    }

    onCreateNewPalette(paletteName.trim());
    closeDialog();
  };

  useImperativeHandle(ref, () => ({
    openDialog,
  }));

  return (
    <Modal
      open={open}
      onClose={closeDialog}
      contanerClassName="w-full max-w-[90vw] sm:max-w-[500px] md:max-w-[600px] bg-white shadow-xl mx-4"
    >
      <div className="flex items-center justify-between p-4 sm:p-6">
        <h2 className="text-xl font-medium sm:text-2xl md:text-3xl">Create New Palette</h2>
        <button onClick={closeDialog} className="rounded p-1 hover:bg-gray-100">
          <Xbutton />
        </button>
      </div>
      <hr className="border-gray-200" />
      <div className="p-4 sm:p-6">
        <form onSubmit={handleSubmit}>
          <div className="mt-2 sm:mt-4">
            <div className="w-full sm:w-2/3">
              <label htmlFor="paletteName" className="mb-1 block text-sm font-medium">
                Name
              </label>
              <input
                id="paletteName"
                type="text"
                value={paletteName}
                onChange={(e) => setPaletteName(e.target.value)}
                placeholder="Enter palette title"
                className="w-full rounded border border-gray-300 p-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none sm:text-base"
                autoFocus
              />
              {error && <div className="mt-1 text-sm text-red-500">{error}</div>}
            </div>
          </div>
        </form>
      </div>
      <div className="flex flex-col justify-start gap-2 p-4 sm:flex-row">
        <button
          onClick={handleSubmit}
          className="hover:bg-black-700 h-10 w-full min-w-[71px] cursor-pointer rounded-3xl bg-black px-4 py-2 text-sm text-white sm:w-auto sm:text-base"
        >
          Save
        </button>
        <button
          onClick={closeDialog}
          className="hover:bg-gray-3 h-10 w-full min-w-[90px] cursor-pointer rounded-3xl border border-black bg-[#f5f5f5] px-4 py-2 text-sm text-gray-700 transition-all duration-300 ease-in-out hover:scale-105 hover:text-gray-900 hover:shadow-md sm:w-auto sm:text-base"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
});

PaletteCreate.displayName = 'PaletteCreate';

export default PaletteCreate;
